<template>
  <div class="dashboard-orders">
    <router-view></router-view>
  </div>
</template>

<script>
import OrdersList from './OrdersList.vue';
import OrderDetail from './OrderDetail.vue';
export default {
  children: [
    {
      path: '',
      component: OrdersList
    },
    {
      path: ':id',
      props: true,
      component: OrderDetail
    }
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/orders/Orders.vue